import { normalizePhaseApplicability, phaseFilterMatchesRecord, resolveLearnerPhaseContext } from './phaseApplicability.js';

/** A view selection only; never pass it to rule eligibility or recording. */
export function normalizePhaseViewIds(ids = []) {
  return normalizePhaseApplicability({ mode: ids.length ? 'selected-phases' : 'whole-school', phaseIds: ids }).phaseIds;
}

export function filterRecordedPhases(records, phaseIds, schoolId) {
  return (records || []).filter(record => phaseFilterMatchesRecord(record.originalData || record, phaseIds, schoolId));
}

export function filterCurrentPhaseLearners(learners, phaseIds, directory) {
  if (!phaseIds.length) return learners || [];
  return (learners || []).filter(learner => {
    const context = resolveLearnerPhaseContext({ ...directory, learner });
    return context.status === 'known' && phaseIds.includes(context.phaseId);
  });
}

/** Default only when every class in existing organisational coverage resolves. */
export function defaultPhaseViewIds({ classIds, ...directory }) {
  if (!classIds?.size) return [];
  const contexts = [...classIds].map(classId => resolveLearnerPhaseContext({ ...directory, learner: { classId } }));
  if (contexts.some(context => context.status !== 'known')) return [];
  return [...new Set(contexts.map(context => context.phaseId))].sort();
}

/** One working-view choice. This never grants access or selects a rule process. */
export function resolveWorkingScope({ role, phases = [], myPhaseIds = [], choice, hasAssignedScope = true }) {
  const admin = ['admin', 'dev'].includes(role);
  // Only confirmed absence of organisational coverage triggers the staff fallback.
  const unassignedStaff = !admin && !['parent', 'student', 'learner'].includes(role)
    && Boolean(role) && hasAssignedScope === false;
  if (unassignedStaff) return { options: [{ key: 'school', label: 'Whole school' }],
    selectedKey: 'school', label: 'Whole school', phaseIds: [], configurationPhaseIds: [], level: 'school' };
  const options = admin
    ? [{ key: 'school', label: 'Whole school' }, ...phases.map(phase => ({
      key: `phase:${phase.id}`, label: `${phase.name}${phase.retired === true || phase.active === false ? ' (retired)' : ''}`,
    }))]
    : myPhaseIds.length ? [{ key: 'my-phase', label: myPhaseIds.length === 1 ? 'My phase' : 'My phases' }] : [];
  options.push({ key: 'scope', label: 'My scope' });
  const selected = options.find(option => option.key === choice) || options.find(option => option.key === (admin ? 'school' : 'scope'));
  const phaseIds = selected.key === 'my-phase' ? myPhaseIds
    : selected.key.startsWith('phase:') ? [selected.key.slice(6)] : [];
  return { options, selectedKey: selected.key, label: selected.label, phaseIds,
    configurationPhaseIds: selected.key === 'scope' ? myPhaseIds : phaseIds,
    level: selected.key === 'scope' ? 'scope' : 'school' };
}
